import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventDeviceFields from './EventDeviceFields'

export const EventDeviceCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <EventDeviceFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default EventDeviceCreate
